import { useState } from "react";
import Layout from "@/components/Layout";
import { INTERIOR_MOOD, RESTAURANT } from "@/lib/constants";

const TIMES = ["12:00","12:30","13:00","13:30","14:00","19:00","19:30","20:00","20:30","21:00","21:30","22:00"];

export default function PrenotazioniPage() {
  const today = new Date().toISOString().split("T")[0];
  const [form, setForm] = useState({
    name: "", email: "", phone: "", date: today, time: "20:00", guests: 2, notes: "",
  });

  const onChange = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = (e) => {
    e.preventDefault();
    const subject = encodeURIComponent(`Richiesta prenotazione — ${form.date} ${form.time}`);
    const body = encodeURIComponent(
      `Buongiorno,

vorrei prenotare un tavolo al Ristorante Pedrocchi.

Nome e cognome: ${form.name}
Email: ${form.email}
Telefono: ${form.phone}
Data: ${form.date}
Ora: ${form.time}
Coperti: ${form.guests}

Note: ${form.notes || "—"}

Grazie.`
    );
    window.location.href = `mailto:${RESTAURANT.email}?subject=${subject}&body=${body}`;
  };

  return (
    <Layout>
      <section className="border-b border-ink">
        <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-16 pt-16 md:pt-24 pb-12 md:pb-20 text-center">
          <div className="overline mb-6">Capitolo III — Prenotazioni</div>
          <h1 className="font-serif text-5xl md:text-7xl leading-[0.95]">
            Un tavolo <em className="text-wine">per te.</em>
          </h1>
          <p className="text-ink-mid mt-8 max-w-2xl mx-auto leading-relaxed">
            Compila il modulo qui sotto: si aprirà la tua app di posta con
            l'email già pronta da inviare. Risponderemo personalmente entro
            poche ore.
          </p>
        </div>
      </section>

      <section className="section">
        <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-16 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20">
          <div className="lg:col-span-5 order-2 lg:order-1">
            <div className="aspect-[4/5] border border-ink overflow-hidden">
              <img src={INTERIOR_MOOD} alt="Sala del ristorante" className="w-full h-full object-cover duotone" />
            </div>
            <div className="mt-8">
              <div className="overline mb-3">Note importanti</div>
              <ul className="text-ink-mid leading-relaxed list-none space-y-2 font-mono text-xs">
                <li>· Per gruppi superiori a 10 persone telefonare in sede.</li>
                <li>· Cancellazioni accettate fino a 4 ore prima.</li>
                <li>· Mercoledì giorno di chiusura.</li>
                <li>· Telefono: <a href={`tel:${RESTAURANT.phone}`} className="text-ink underline">{RESTAURANT.phone}</a></li>
                <li>· Email: <a href={`mailto:${RESTAURANT.email}`} className="text-ink underline">{RESTAURANT.email}</a></li>
              </ul>
            </div>
          </div>

          <div className="lg:col-span-7 order-1 lg:order-2">
            <form onSubmit={submit} className="flex flex-col gap-7" data-testid="reservation-form">
              <div>
                <label className="overline block mb-2">Nome e cognome</label>
                <input required type="text" value={form.name} onChange={onChange("name")}
                  className="ink-input" placeholder="Mario Rossi"
                  data-testid="reservation-name-input" />
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-7">
                <div>
                  <label className="overline block mb-2">Email</label>
                  <input required type="email" value={form.email} onChange={onChange("email")}
                    className="ink-input" placeholder="email@esempio.it"
                    data-testid="reservation-email-input" />
                </div>
                <div>
                  <label className="overline block mb-2">Telefono</label>
                  <input required type="tel" value={form.phone} onChange={onChange("phone")}
                    className="ink-input" placeholder="+39 ..."
                    data-testid="reservation-phone-input" />
                </div>
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-3 gap-7">
                <div>
                  <label className="overline block mb-2">Data</label>
                  <input required type="date" value={form.date} min={today} onChange={onChange("date")}
                    className="ink-input" data-testid="reservation-date-input" />
                </div>
                <div>
                  <label className="overline block mb-2">Ora</label>
                  <select value={form.time} onChange={onChange("time")} className="ink-input" data-testid="reservation-time-select">
                    {TIMES.map((t) => <option key={t} value={t}>{t}</option>)}
                  </select>
                </div>
                <div>
                  <label className="overline block mb-2">Coperti</label>
                  <input required type="number" min={1} max={40} value={form.guests} onChange={onChange("guests")}
                    className="ink-input" data-testid="reservation-guests-input" />
                </div>
              </div>
              <div>
                <label className="overline block mb-2">Note (opzionale)</label>
                <textarea value={form.notes} onChange={onChange("notes")} rows={3}
                  className="ink-input" placeholder="Allergie, intolleranze, occasioni speciali…"
                  data-testid="reservation-notes-input" />
              </div>

              <div className="pt-4">
                <button type="submit" className="btn-primary" data-testid="reservation-submit-button">
                  Invia richiesta
                </button>
                <p className="font-mono text-[0.65rem] tracking-wider text-ink-mid mt-4">
                  Premendo "Invia richiesta" si aprirà la tua app di posta con il messaggio già pronto.
                </p>
              </div>
            </form>
          </div>
        </div>
      </section>
    </Layout>
  );
}
